import { connectSpaceOrderLabel } from './connectSpaceOrderLabel';
import { SpaceOrderLabel as SpaceOrderLabelPure } from './SpaceOrderLabel';

export const SpaceOrderLabel = connectSpaceOrderLabel(SpaceOrderLabelPure);
